@if (lazyLoadingService.$isLoading | async) {
  <div class="fixed top-0 left-0 w-full h-full bg-white dark:bg-gray-800/80 dark:bg-gray-900/80 flex justify-center items-center z-50">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
